/**
 * FetchV — video downloader for m3u8 / HLS streams
 *
 * Declares one web-accessible-resource entry matched to every origin with no
 * `use_dynamic_url`, exposing exactly three files: `js/hook.js`, `js/mediabunny.js` and
 * `img/recording.svg`. All are reachable from any page at a fixed URL. The vendor-named
 * `img/recording.svg` loads through `probeImage` with no CORS grant, so it survives a
 * restrictive page CSP.
 *
 * Manifest verified against version 3.2.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nfmmmhanepmpifddlkkmihkalkoekpfd';

export const fetchv: ExtensionDefinition = {
  id: ID,
  name: 'FetchV - Video Downloader for m3u8 & hls',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Three static WAR on every origin with no dynamic URL. The recording.svg image ' +
    'loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-recording-svg',
      kind: 'web-accessible-resource',
      description:
        'Load img/recording.svg via <img> — a vendor-named icon exposed to every ' +
        'origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'img/recording.svg'),
    },
    {
      id: 'war-hook-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/hook.js — the page-hook injected script, a second static path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/hook.js'),
    },
    {
      id: 'war-mediabunny-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/mediabunny.js — a distinctively-named bundle, independent of the ' +
        'image and hook paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/mediabunny.js'),
    },
  ],
};
